import clsx from 'clsx';
import { useEffect } from 'react';

import { TOAST_TIMEOUT_MS, useToastStore, type Toast, type ToastTone } from './toast-store';
import styles from './Toaster.module.css';

const ICON: Readonly<Record<ToastTone, string>> = {
  success: '✓',
  error: '✕',
  warn: '⚠',
  info: '✦',
};

function ToastRow({ toast }: { toast: Toast }) {
  const dismiss = useToastStore((s) => s.dismiss);

  useEffect(() => {
    const timer = setTimeout(() => {
      dismiss(toast.id);
    }, TOAST_TIMEOUT_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [toast.id, dismiss]);

  return (
    <output
      className={clsx(styles.toast, toast.tone !== 'success' && styles[toast.tone])}
      aria-live={toast.tone === 'error' ? 'assertive' : 'polite'}
    >
      <span className={styles.icon} aria-hidden="true">
        {ICON[toast.tone]}
      </span>
      {toast.message}
      <button
        type="button"
        className={styles.dismiss}
        onClick={() => {
          dismiss(toast.id);
        }}
        aria-label="Dismiss notification"
      >
        ✕
      </button>
    </output>
  );
}

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  return (
    <div className={styles.wrap}>
      {toasts.map((t) => (
        <ToastRow key={t.id} toast={t} />
      ))}
    </div>
  );
}
